import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar } from '@fullcalendar/core';

export function initCalPosts(cal: Calendar) {
  p('initCalPosts');

  const calendar = cal;
  Cookies.set('post_back', window.location.href, { path: '/' });
  Cookies.set('launch_area_back', window.location.href, { path: '/' });

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default btn-sm margin-5px',
    html: '<i class="fa fa-bullhorn"></i> SVB Közlemények'
  });
  $('#btnContainer').append(btn);

  const source = calendar.addEventSource({
    url: '/posts.json',
    extraParams: {
      'q[launch_areas_id_eq]': $('#q_launch_area_id_eq').val()
    }
  });
  source.remove();

  let active = !(Cookies.get('cal_no_posts') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.css('background-color', '#fce2d4') : btn.css('background-color', 'white');
    active ? calendar.addEventSource(source) : source.remove();
    Cookies.set('cal_no_posts', (!active) + '', {
      expires: 10,
      path: '/'
    });
  }

}